import React, { useMemo } from "react";
import { CounterpartyDirectoryView } from "@common/types/views/counterpartyDirectoryView";
import { View } from "@common/types/views/views";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import {
    FilterTabs,
    FiltersChangeFn,
} from "@components/pageHeader/filters/lib";
import { glDirectionRadios } from "@components/pageHeader/filters/Tabs/AmountFilter/directionRadios";
import { useCounterpartyDirectoryViewConfig } from "@components/settings/Directory/useCounterpartyDirectoryViewConfig";
import { ColumnSettings } from "@design-system/ViewToolbar/ColumnSettings";
import styles from "./CloseTemplateTaskTransactionsPreview.module.scss";

interface Props {
    view: CounterpartyDirectoryView;
    onViewChange: (view: View) => void;
    onFiltersChange: FiltersChangeFn;
    availableFilters: FilterTabs[];
    createDefaultView: () => CounterpartyDirectoryView;
    children?: React.ReactNode;
}

export const CloseTemplateCounterpartyPreviewHeader: React.FC<Props> = ({
    view,
    onViewChange,
    onFiltersChange,
    availableFilters,
    createDefaultView,
    children,
}) => {
    const { viewConfig: directoryViewConfig } =
        useCounterpartyDirectoryViewConfig();
    const defaultView = useMemo(() => createDefaultView(), [createDefaultView]);

    return (
        <TablePageHeader
            className={styles.filters}
            filters={view.filters}
            onFiltersChange={onFiltersChange}
            availableFilters={availableFilters}
            directionRadios={glDirectionRadios}
            showAmountFilterLevel
            hideCoaAccountLastChangedBy
            isFullPage
        >
            <ColumnSettings
                view={view}
                viewConfig={directoryViewConfig}
                defaultView={defaultView}
                onViewChange={onViewChange}
            />
            {children}
        </TablePageHeader>
    );
};
